export const BUILTIN_APP_TEMPLATES = [
  {
    name: 'Model',
    image: {
      url: 'asset://Model.png',
    },
    model: 'asset://Model.glb',
    script: 'asset://Model.js',
    props: {
      collision: true,
    },
    preload: false,
    public: false,
    locked: false,
    frozen: false,
    unique: false,
    scene: false,
    disabled: false,
  },
  {
    name: 'Image',
    image: {
      url: 'asset://Image.png',
    },
    model: 'asset://Image.glb',
    script: 'asset://Image.js',
    props: {
      width: 0,
      height: 2,
      fit: 'cover',
      image: null,
      transparent: false,
      lit: false,
      shadows: true,
      placeholder: {
        type: 'image',
        url: 'asset://Image.png',
      },
    },
    preload: false,
    public: false,
    locked: false,
    frozen: false,
    unique: false,
    scene: false,
    disabled: false,
  },
  {
    name: 'Video',
    image: {
      url: 'asset://Video.png',
    },
    model: 'asset://Video.glb',
    script: 'asset://Video.js',
    props: {
      width: 0,
      height: 2,
      fit: 'cover',
      url: null,
      loop: true,
      autoplay: true,
      transparent: false,
      lit: false,
      shadows: true,
      placeholder: {
        type: 'video',
        url: 'asset://Video.mp4',
      },
    },
    preload: false,
    public: false,
    locked: false,
    frozen: false,
    unique: false,
    scene: false,
    disabled: false,
  },
  {
    name: 'Text',
    image: {
      url: 'asset://Text.png',
    },
    model: 'asset://Text.glb',
    script: 'asset://Text.js',
    props: {
      width: 200,
      height: 200,
      text: 'Enter text...',
      fontSize: 20,
      fontWeight: 'bold',
      color: '#ffffff',
      transparent: false,
      lit: false,
      shadows: true,
    },
    preload: false,
    public: false,
    locked: false,
    frozen: false,
    unique: false,
    scene: false,
    disabled: false,
  },
]
